"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireDefault(require("react"));

var _commonCta = require("@mmc/common-cta");

var _configuratorSmallSummary = _interopRequireDefault(require("../styles/configurator-small-summary.css"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import DEFAULT_PROPS from "./configurator-small-summary.props/configurator-small-summary.defaultProps";
var ShareLink = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(ShareLink, _React$Component);

  function ShareLink(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasCopied: false
    };
    _this.linkTextArea = /*#__PURE__*/_react["default"].createRef();
    _this.timer = 1500;
    _this.copyTextToClipboard = _this.copyTextToClipboard.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = ShareLink.prototype;

  _proto.getSelection = function getSelection(linkTextArea) {
    var range = document.createRange(); // eslint-disable-line

    range.selectNodeContents(linkTextArea);

    if (typeof window !== 'undefined') {
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }
  };

  _proto.fallbackCopyTextToClipboard = function fallbackCopyTextToClipboard(buttonEl) {
    var _this2 = this;

    var linkTextArea = this.linkTextArea.current;
    var maxSelection = 999999;
    linkTextArea.focus();
    linkTextArea.select();

    try {
      if (typeof window !== 'undefined') {
        linkTextArea.contentEditable = true;
        linkTextArea.readOnly = false;
        this.getSelection(linkTextArea);
        linkTextArea.setSelectionRange(0, maxSelection);
        document.execCommand('copy'); // eslint-disable-line

        linkTextArea.setSelectionRange(0, 0);
        buttonEl.focus();
        this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
          hasCopied: true
        }));
        window.setTimeout(function () {
          return _this2.setState(_objectSpread(_objectSpread({}, _this2.state), {}, {
            hasCopied: false
          }));
        }, this.timer);
      }
    } catch (err) {// Could not copy
    }
  };

  _proto.copyTextToClipboard = function copyTextToClipboard(e) {
    var _this3 = this;

    if (typeof navigator !== 'undefined') {
      if (!navigator.clipboard) {
        // eslint-disable-line
        this.fallbackCopyTextToClipboard(e.target);
        return;
      }

      var textToCopy = this.linkTextArea.current.value;
      navigator.clipboard.writeText(textToCopy).then(function () {
        // eslint-disable-line
        if (typeof window !== 'undefined') {
          _this3.setState(_objectSpread(_objectSpread({}, _this3.state), {}, {
            hasCopied: true
          }));

          window.setTimeout(function () {
            return _this3.setState(_objectSpread(_objectSpread({}, _this3.state), {}, {
              hasCopied: false
            }));
          }, _this3.timer);
        }
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        rootUrl = _this$props.rootUrl,
        configuratorCode = _this$props.configuratorCode,
        copyText = _this$props.copyText;
    var hasCopied = this.state.hasCopied;
    var theme = this.props.theme || {};
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _configuratorSmallSummary["default"].shareLinkWrapper + " " + (hasCopied ? _configuratorSmallSummary["default"].hasCopied : '')
    }, /*#__PURE__*/_react["default"].createElement("input", {
      type: "url",
      ref: this.linkTextArea,
      className: _configuratorSmallSummary["default"].shareLinkTextArea + " " + theme.bodyCopy,
      readOnly: true,
      contentEditable: false,
      name: "shareURL",
      value: "" + rootUrl + configuratorCode
    }), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: {
        priority: 'low',
        label: copyText
      },
      classes: [_configuratorSmallSummary["default"].copyLink],
      theme: theme,
      clickEvent: this.copyTextToClipboard
    }));
  };

  return ShareLink;
}(_react["default"].Component);

exports["default"] = ShareLink;
ShareLink.displayName = 'ShareLink';
ShareLink.defaultProps = {
  theme: {}
};